module.exports = __webpack_public_path__ + "img/locker_2.df638117.png";